import React from 'react';
import { styled } from '@compiled/react';
import ArrowLeftIcon from '@atlaskit/icon/core/migration/arrow-left';
import ArrowRightIcon from '@atlaskit/icon/core/migration/arrow-right';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Direction = 'LEFT' | 'RIGHT';

interface Props {
	direction: Direction;
	onClick: () => void;
}

export const Arrow = ({ direction, onClick }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<Wrapper onClick={onClick} direction={direction}>
			{direction === 'LEFT' ? (
				<ArrowLeftIcon spacing="spacious" label={formatMessage(messages.leftArrowlabel)} />
			) : (
				<ArrowRightIcon spacing="spacious" label={formatMessage(messages.rightArrowlabel)} />
			)}
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.button<{ direction: Direction }>({
	pointerEvents: 'all',
	position: 'absolute',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	left: ({ direction }) => (direction === 'LEFT' ? token('space.negative.150') : 'auto'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	right: ({ direction }) => (direction === 'RIGHT' ? token('space.negative.150') : 'auto'),
	top: token('space.800'),
	width: token('space.300'),
	height: token('space.300'),
	borderRadius: token('space.150'),
	backgroundColor: token('color.background.input'),
	color: token('color.text'),
	border: 'none',
	padding: 0,
	font: 'inherit',
	cursor: 'pointer',
	outline: 'inherit',
	boxShadow: `${token('elevation.shadow.overlay')}`,
	'&:hover': {
		backgroundColor: token('elevation.surface.pressed'),
	},
	'&:focus': {
		backgroundColor: token('elevation.surface.hovered'),
	},
});
